import { html } from "lit";
var icon_edit_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="M22.96 2.48l6.486 6.484c.552.553.552 1.472-.21 2.098l-17.25 17.265c-.142.141-.35.209-.592.192l-6.757.37c-.62-.044-1.305-.612-1.53-1.27a1.235 1.235 0 01-.07-.33l.372-6.734c-.017-.243.05-.45.192-.592l17.367-17.19c.828-.9 1.993-.294 1.993-.294zm-5.794 6.697L5.469 20.874a.714.714 0 00-.195.367l-.014.109-.306 4.63c-.006.08 0 .164.019.247.097.446.504.793.938.82h.11l4.629-.307a.749.749 0 00.396-.141l.08-.068 11.697-11.697-5.657-5.657zm4.576-4.564l-.084.071-2.905 2.906 5.657 5.657 2.905-2.906c.316-.315.273-.869-.096-1.237L22.896 4.78c-.338-.337-.831-.401-1.154-.167z"
      fill-rule="evenodd" />
  </svg>
`;
export {
  icon_edit_default as default
};
//# sourceMappingURL=icon-edit.js.map
